/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { Icon, CustomValidation, Button } from 'sarsaparilla';

export default class AlternatePermitHolderEntry extends React.PureComponent {
    static propTypes = {
        alternateLeaderValidatorMethod: PropTypes.func,
        handleAlternateLeaderValidation: PropTypes.func,
        className: PropTypes.string,
        handleAlternateLeaderChange: PropTypes.func,
        isDisabled: PropTypes.bool,
        index: PropTypes.number,
        leader: PropTypes.object,
        removeLeader: PropTypes.func,
    };

    static defaultProps = {
        isDisabled: false,
        className: '',
    };

    onClickRemove = () => this.props.removeLeader(parseInt(this.props.index, 10));

    handleChange = ({ target: { id, value } }) =>
        this.props.handleAlternateLeaderChange(this.props.index, id, value.trim());

    renderRemoveLeaderButton() {
        if (this.props.isDisabled) {
            return <div />;
        }

        return (
            <div className="alternate-group-leader">
                <Button
                    type="button"
                    appearance="subtle-danger"
                    onClick={this.onClickRemove}
                    iconBeforeElement={<Icon iconName="delete" />}
                    screenReaderTextBefore="Close"
                />
            </div>
        );
    }

    render() {
        const { className, index, isDisabled, leader } = this.props;
        return (
            <div className="permit-alt-input-wrap">
                <div className="permit-alt-header-wrap">
                    <div className="permit-alt-header">
                        Alternate Permit Holder #{index + 1}
                    </div>
                    {this.renderRemoveLeaderButton()}
                </div>
                <div className="rec-form-item-wrap">
                    <label htmlFor={`alt-email-${index + 1}`}>Email Address</label>
                    <input
                        id={`alt-email-${index + 1}`}
                        type="text"
                        className={className}
                        value={get(leader, 'email', '').trim()}
                        onChange={this.handleChange}
                        readOnly={isDisabled}
                        disabled={isDisabled}
                    />
                    <CustomValidation
                        value={get(leader, 'email', '').trim()}
                        displayInSummary
                        customValidator={this.props.alternateLeaderValidatorMethod}
                        onValidated={this.props.handleAlternateLeaderValidation}
                        controlLabel="Alternate Permit Holder Email Address"
                    />
                </div>
            </div>
        );
    }
}
